import React, { Component } from 'react';
import { connect } from 'react-redux';
import { actions, Form } from 'react-redux-form';
import { Col, Row } from 'react-bootstrap';
import RequiredInput from '../../common/form/elements/required-input';
import RequiredTextarea from '../../common/form/elements/required-textarea';
import SearchableSelect from '../../common/form/elements/searchable-select';
import UserTitleSelector from '../../common/form/user/user-title-selector';
import ArrowButton from '../../common/button-arrow';
import { saveContact } from '../../../actions/contacts';


class ContactForm extends Component {
  constructor(props) {
    super(props);
    this.state = {
      enquirySelected: null
    };
  }

  onSubmit = (payLoad) => {
    this.props.dispatch(actions.submitFields('deep.contact_us', saveContact(payLoad)));
  };

  handleEnquiryChange = (value) => {
    this.props.dispatch(actions.change('deep.contact_us.type_of_enquiry', value));
    this.setState({
      enquirySelected: value
    });
  }

  render() {
    const enquiries = this.props.enquiries.map(enquiry => (
      {
        value: enquiry,
        label: enquiry
      }
    ));

    return (
      <Form
        model="deep.contact_us"
        onSubmit={this.onSubmit}
      >
        <Row>
          <Col lg={6}>
            <UserTitleSelector
              model="deep.contact_us.title"
            />

            <RequiredInput
              label="Name"
              model=".name"
            />

            <RequiredInput
              label="Store Name"
              model=".store_name"
            />

            <RequiredInput
              inputType="email"
              label="Email"
              model=".email"
            />

            <RequiredInput
              label="Telephone"
              model=".telephone"
            />
          </Col>

          <Col lg={6}>
            <SearchableSelect
              label="Type of enquiry"
              model="deep.contact_us.type_of_enquiry"
              options={enquiries}
              value={this.state.enquirySelected}
              onChange={value => this.handleEnquiryChange(value)}
            />

            <RequiredTextarea
              label="Message"
              model=".message"
            />

            <ArrowButton
              arrow={false}
              disabled={!this.props.formValid}
              className="pull-right"
              ghost={false}
            >
              Submit
            </ArrowButton>
          </Col>
        </Row>
      </Form>
    );
  }
}

const mapStateToProps = state => ({
  contactUs: state.deep.forms.contact_us,
  formValid: state.deep.forms.contact_us.$form.valid
});

export default connect(mapStateToProps)(ContactForm);



// WEBPACK FOOTER //
// ./src/components/contact-us/pre-login/contact-us-form.jsx